import {
  Bootstrap,
  Css3,
  Figma,
  Git,
  Github,
  Html5,
  Javascript,
  ReactLogo,
  Sass,
} from "@styled-icons/boxicons-logos";
import {
  MessageAlt,
  MessageAltDots,
  Terminal,
} from "@styled-icons/boxicons-regular";
import { Ruby } from "@styled-icons/octicons";
import {
  Adobeaftereffects,
  Adobeillustrator,
  Adobephotoshop,
  Adobepremierepro,
  Bulma,
  Linux,
  Postgresql,
  Rubyonrails,
  Styledcomponents,
  Vite,
} from "@styled-icons/simple-icons";

export const devSkills = [
  {
    id: 1,
    name: "JavaScript",
    icon: <Javascript />,
    color: "#f0db4f",
  },
  {
    id: 2,
    name: "React",
    icon: <ReactLogo />,
    color: "#0d96b4",
  },
  {
    id: 3,
    name: "Ruby",
    icon: <Ruby />,
    color: "#e43717",
  },
  {
    id: 4,
    name: "Vite",
    icon: <Vite />,
    color: "#5daeff",
  },
  {
    id: 5,
    name: "Ruby on Rails",
    icon: <Rubyonrails />,
    color: "#d30001",
  },
  {
    id: 6,
    name: "HTML",
    icon: <Html5 />,
    color: "#e14e1d",
  },
  {
    id: 7,
    name: "CSS3",
    icon: <Css3 />,
    color: "#0277bd",
  },
  {
    id: 8,
    name: "Sass",
    icon: <Sass />,
    color: "#cd6799",
  },
  {
    id: 9,
    name: "Bootstrap",
    icon: <Bootstrap />,
    color: "#7812f8",
  },
  {
    id: 10,
    name: "Bulma",
    icon: <Bulma />,
    color: "#00d0b1",
  },
  {
    id: 11,
    name: "Linux",
    icon: <Linux />,
    color: "#0277bd",
  },
  {
    id: 12,
    name: "PostgreSQL",
    icon: <Postgresql />,
    color: "#336791",
  },
  {
    id: 13,
    name: "Styled Components",
    icon: <Styledcomponents />,
    color: "#7812f8",
  },
  {
    id: 14,
    name: "GitHub",
    icon: <Github />,
    color: "#336791",
  },
  {
    id: 15,
    name: "Git",
    icon: <Git />,
    color: "#f03c2e",
  },
  {
    id: 16,
    name: "Terminal",
    icon: <Terminal />,
    color: "#336791",
  },
];
export const designSkills = [
  {
    id: 1,
    name: "Adobe Photoshop",
    icon: <Adobephotoshop />,
    color: "#31a8ff",
  },
  {
    id: 2,
    name: "Adobe Illustrator",
    icon: <Adobeillustrator />,
    color: "#ff9a00",
  },
  {
    id: 3,
    name: "Adobe Premiere",
    icon: <Adobepremierepro />,
    color: "#3a3a99",
  },
  {
    id: 4,
    name: "Adobe After Effects",
    icon: <Adobeaftereffects />,
    color: "#9999ff",
  },
  {
    id: 5,
    name: "Figma",
    icon: <Figma />,
    color: "#0acf83",
  },
];
export const languages = [
  {
    id: 1,
    name: "English",
    icon: <MessageAlt />,
    color: "#e43717",
  },
  {
    id: 2,
    name: "Spanish",
    icon: <MessageAltDots />,
    color: "#0077b5",
  },
];
